

import React, { memo } from 'react';

import cx from 'classnames';
import onEnterPressed from '../../../common/utils/onEnterPressed';
import Icon from '../../Icon';
import Text from '../../Text';
import { CHECKBOX, CHECKBOX_CONTAINER, CHECKBOX_CONTENT } from '../styles/checkbox';











const Checkbox = (
{ checked, onChange, children, className, disabled, darkMode, prefixIcon }) =>
{
  const onClickFunction = disabled ? void 0 : onChange;

  return (
    <div
      className={cx(
        CHECKBOX_CONTAINER({ disabled, checked, darkMode }),
        'check-box',
        { 'check-box__checked': checked },
        { 'check-box__disabled': disabled },
        className
      )}
      onKeyDown={onEnterPressed({ onClick: onClickFunction })}
      onClick={onClickFunction}
      tabIndex={0}
      role="button">

      <div className={cx(CHECKBOX({ checked, darkMode, disabled }), 'check-box__box')}>
        {checked &&
        <Icon
          className="check-box__box__check-icon"
          name="success"
          color={disabled ? 'nevada' : 'white'}
          size={10} />}


      </div>
      {children &&
      <div className={cx(CHECKBOX_CONTENT({ darkMode }), 'check-box__content')}>
          {prefixIcon && <Icon size={20} color="denim" name={prefixIcon} />}
          {typeof children === 'string' ? <Text noMargin>{children}</Text> : children}
        </div>}

    </div>);

};

export default memo(Checkbox);